import logger from './logger';

const runtimeConfig = window.__APP_CONFIG__ || {};
const configuredBase = runtimeConfig.API_BASE_URL || process.env.REACT_APP_API_BASE_URL || '/backend/api';
const API_BASE_URL = configuredBase.replace(/\/$/, '');

const requestId = () => `web-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

export const getApiBaseUrl = () => API_BASE_URL;

export const apiRequest = async (path, options = {}) => {
  const startedAt = Date.now();
  const id = requestId();
  const headers = {
    Accept: 'application/json',
    ...((typeof FormData !== 'undefined' && options.body instanceof FormData) ? {} : { 'Content-Type': 'application/json' }),
    'X-Request-Id': id,
    ...(options.headers || {}),
  };

  const response = await fetch(`${API_BASE_URL}/${path.replace(/^\//, '')}`, {
    credentials: 'include',
    ...options,
    headers,
  });
  const responseRequestId = response.headers.get('X-Request-Id') || id;
  const body = await response.json().catch(() => null);
  const duration = Date.now() - startedAt;

  logger.info('API request completed', {
    method: options.method || 'GET',
    path,
    status: response.status,
    durationMs: duration,
    requestId: responseRequestId,
  });

  if (!response.ok || !body || body.success === false) {
    const error = new Error(body && body.message ? body.message : 'Une erreur réseau est survenue.');
    error.status = response.status;
    error.requestId = responseRequestId;
    logger.error('API request failed', { path, status: response.status, requestId: responseRequestId });
    throw error;
  }

  return body;
};

export default apiRequest;
